import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const mandatoryTopics = ['Basic Defensive Handgun Skills', 'Firearms and the Law: Possession, Ownership, and the use of Deadly Force'];
const optionalTopics = ['Introduction to Defensive Shooting', 'Strategies for Home Safety and Responding to a Violent Confrontation', 'Selecting a Handgun for Self-Defense', 'Sport Shooting Activities and Training Opportunities'];
export function CourseOverview() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1115">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1116">
        <div className="mb-12" data-id="element-1117">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1118">
            Course Overview
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1119">
            <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-1120">
              <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-100" data-id="element-1121">
                <div className="px-3 py-1 rounded text-xs font-bold uppercase tracking-wider" style={{
                backgroundColor: '#1e3d2f',
                color: '#ffffff'
              }} data-id="element-1122">
                  Mandatory
                </div>
              </div>
              <ul className="space-y-3" data-id="element-1123">
                {mandatoryTopics.map(topic => <li key={topic} className="flex items-start gap-3" data-id="element-1124">
                    <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
                  color: '#1e3d2f'
                }} data-id="element-1125" />
                    <span className="text-sm text-gray-800" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-1126">
                      {topic}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm border" style={{
            borderColor: '#ede9e0'
          }} data-id="element-1127">
              <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-100" data-id="element-1128">
                <div className="px-3 py-1 rounded text-xs font-bold uppercase tracking-wider" style={{
                backgroundColor: 'rgba(200,168,75,0.15)',
                color: '#8a7230'
              }} data-id="element-1129">
                  Optional
                </div>
              </div>
              <ul className="space-y-3" data-id="element-1130">
                {optionalTopics.map(topic => <li key={topic} className="flex items-start gap-3" data-id="element-1131">
                    <div className="w-2 h-2 rounded-full flex-shrink-0 mt-2" style={{
                  backgroundColor: '#c8a84b'
                }} data-id="element-1132" />
                    <span className="text-sm text-gray-800" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-1133">
                      {topic}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}